import React, { useEffect } from 'react';
import Flow from './FlowChartHome/FlowChartHome';
import { useContextData } from '../../../core/context';
import { Spinner } from 'react-bootstrap';
// import { useGlobalContextData } from '../../../../core/context/AdminContext/GlobalContext';

const Geneology = () => {
    const { getReferralData, referralData, myProfile, referralLoading } = useContextData();

    useEffect(() => {
        getReferralData()
    }, [])
    return (
        <div className='h-100 px-3 mb-3'>
            <div>
                <h1 style={{ fontSize: '1.5rem' }}><strong>Geneology</strong></h1>
            </div>
            <div className='w-100 h-100'>
                {
                    referralLoading ? <div className='d-flex justify-content-center align-items-center'>
                        <Spinner aria-label="Spinner button example" size="sm" />
                    </div> :
                        <Flow
                            getReferralStake={referralData} user={myProfile}
                        />
                }
            </div>
        </div>
    );
};

export default Geneology;